import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

interface IframeDialogProps {
  src: string;
  title: string;
  onOpenChange: (open: boolean) => void;
  iframeClassName?: string;
  name?: string;
  open?: boolean;
  onIframeLoad?: (iframe: HTMLIFrameElement) => void;
}

export function IframeDialog({
  src,
  onOpenChange,
  title,
  iframeClassName,
  name,
  open = true,
  onIframeLoad,
}: IframeDialogProps) {
  const handleIframeLoad = (event: React.SyntheticEvent<HTMLIFrameElement>) => {
    const iframe = event.currentTarget
    onIframeLoad?.(iframe)
  }

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <iframe 
          name={name} 
          src={src} 
          className={iframeClassName} 
          onLoad={handleIframeLoad}
        />
      </DialogContent>
    </Dialog>
  )
}
